import styled, { css } from 'styled-components';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const ActionsRowRoot = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    min-height: 2rem;
`;

export const ActionsGroup = styled.div<{ $isPrimary: boolean; theme: InterstateTheme }>`
    display: flex;
    align-items: center;
    gap: 0.25rem;

    ${({ $isPrimary, theme }) =>
        $isPrimary &&
        css`
            button:hover:not(:disabled) {
                background-color: ${theme.tokens.SemColorSurfaceDefault};
            }
        `}
`;

export const PrimaryBadge = styled.span<{ theme: InterstateTheme }>`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 1rem;
    line-height: 1.15;
    color: ${({ theme }) => theme.tokens.SemColorSurfaceDefault};
    background-color: ${({ theme }) => theme.tokens.BaseColorBlue900};
`;

export const IconActionWrap = styled.span`
    position: relative;
    display: inline-flex;
`;

export const TemplateAppliedMark = styled.span<{ theme: InterstateTheme }>`
    position: absolute;
    top: -2px;
    right: -2px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    pointer-events: none;
    background-color: ${({ theme }) => theme.tokens.BaseColorGreen600};
    color: ${({ theme }) => theme.tokens.SemColorSurfaceDefault};

    svg {
        width: 8px;
        height: 8px;
    }
`;
